/**
 * Выбор словоформы по числу. Русский требует три формы (1 порция / 2 порции /
 * 5 порций), поэтому одним ключом перевода не обойтись. Для языков без такого
 * согласования вызывающий передаёт один и тот же вариант трижды — правило
 * тогда возвращает его при любом n.
 */
export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
